const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Button, Grid2, CircularProgress } from '@mui/material';
import Loginpopup from './Loginpopup.jsx';

class Submitbutton extends Component {
    constructor(props) {
        super(props);
        this.state = { show_login: false }
    }

    handlelogin = () => {
        this.setState({ show_login: true });
    }

    handleClose = (event) => {
        this.setState({ show_login: false });
    }

    render() {
        const { t, i18n } = this.props;
        let onlyloggedsubmit = this.props.short.onlyloggedsubmit;
        let update_form = this.props.updatecall;
        if (update_form == 1) {
            onlyloggedsubmit = 0;
        }
        const check_logged = this.props.short.user_logged;
        const { btn_loader } = this.props;
        return (
            (<div>
                {onlyloggedsubmit == 1 && check_logged == false &&
                    <Grid2 className="wpvc_save_contestant" size={12}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.handlelogin()}
                            className="wpvc_save_contestant_btn"
                            disabled={btn_loader === 0 ? false : true}>
                            {
                                btn_loader === 0 &&
                                <React.Fragment>
                                    {t("save_contestant")}
                                </React.Fragment>
                            }
                            {
                                btn_loader === 1 &&
                                <React.Fragment>
                                    {t('Processing')}
                                    <CircularProgress className="wpvc_vote_btn_loading" color='inherit' size={16} />
                                </React.Fragment>
                            }
                        </Button>
                        <Loginpopup ORIGINAL_URL={this.props.ORIGINAL_URL} {...this.props} showlog={this.state.show_login} handclose={this.handleClose} handlog={this.handlelogin} />
                    </Grid2>
                }
                {(onlyloggedsubmit == 0 || check_logged == true) &&
                    <Grid2 className="wpvc_save_contestant" size={12}>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={btn_loader === 0 ? false : true}
                            onClick={this.props.saveform}
                            className="wpvc_save_contestant_btn" >
                            {
                                btn_loader === 0 &&
                                <React.Fragment>
                                    {t("save_contestant")}
                                </React.Fragment>
                            }
                            {
                                btn_loader === 1 &&
                                <React.Fragment>
                                    {t('Processing')}
                                    <CircularProgress className="wpvc_vote_btn_loading" color='inherit' size={16} />
                                </React.Fragment>
                            }
                        </Button>
                    </Grid2>
                }
            </div>)
        );
    }
}

export default connect()(withTranslation("translations")(Submitbutton));
